<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ScrollBoard',
  computed: {...mapGetters(['screenWorkSheetList'])},
  data () {
    return {
      config: {
        header: ['工单号', '类型', '客户'],
        data: [
          // ['京郊大集', '自然晾晒红薯干', '1', '88'],
          // ['京郊大集', '黑提玫瑰香葡萄', '3', '66'],
          // ['京郊大集', '密之蓝天乌鸡蛋', '6', '33'],
          // ['席大供应链', '密云流星番茄', '2', '56'],
          // ['京郊大集', '胡家营-黄油桃', '1', '77'],
          // ['京庐', '密云鲜食牛奶玉米', '3', '12'],
          // ['京郊大集', '华浓果源水蜜桃', '4', '67'],
          // ['京庐', '五常香米', '2', '19'],
          // ['席大供应链', '密之蓝天乌鸡蛋', '5', '33'],
          // ['京郊大集', '水库紫皮辫子蒜', '3', '77']
        ],
        index: true,
        columnWidth: [50, 120, 200, 200],
        align: ['center'],
        rowNum: 7,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  },

  mounted () {
    // const { createData } = this
    this.$store.dispatch('screen/screenSet',{}).then(Response=>{
        console.log('this.workSheetList',this.workSheetList);
    });

    this.createData()

  },

  methods: {
    async createData () {
      var _this=this;
      await _this.$store.dispatch('screen/screenSet',{}).then(Response=>{
        // console.log('this.workSheetList',_this.workSheetList)
        _this.screenWorkSheetList.forEach(element => {
          var sub =[];
          console.log('element',element)
          sub.push(element.sheetCode);
          sub.push(element.dictValue);
          sub.push(element.companyName);
          // sub.push(element.contactUser);
          _this.config.data.push(sub)
        });
        
        // console.log('_this.config.data',_this.config.data)     
        _this.config = { ..._this.config }

      })
    }
  },

}
</script>

<style lang="less">
#scroll-board {
  width: 50%;
  box-sizing: border-box;
  margin-left: 20px;
  height: 100%;
  overflow: hidden;
}
</style>
